import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../modules/common/modules/auth/services/auth.service";
import {NotifierService} from "../../../base/services/notifier/notifier.service";
import {EventBusService} from "../../../base/services/eventbus/event-bus.service";
import {EventKey} from "../../../registry/event.key";
import {ActivatedRoute, Router} from "@angular/router";
import {BaseComponent} from "../../../base/components/base.component";
import {SubscriptionContainerService} from "../../../base/services/subscription-container.service";
import {PreRegistrationService} from "./pre-registration.service";
import {ICampaignLeadReq} from "./campaign-lead.model";
import {AuthEndpoint} from "../../../modules/common/modules/auth/auth.endpoint";
import {translations} from "../../../modules/dash/layout/left-nav/menu.model";

@Component({
  selector: 'app-login',
  templateUrl: './pre-registration.component.html',
  styleUrls: ['./pre-registration.component.scss']
})
export class PreRegistrationComponent extends BaseComponent implements OnInit {

  preRegForm = new FormGroup({
    name: new FormControl<string | null>(null, [Validators.required, Validators.minLength(3)]),
    phone: new FormControl<string | null>(null, [Validators.required, Validators.minLength(11), Validators.maxLength(11)]),
    email: new FormControl<string | null>(null, Validators.email),
    package_type: new FormControl<string | null>(null, [Validators.required]),
    business_type: new FormControl<string | null>(null, [Validators.required, Validators.minLength(3)]),
  });

  campaignCode: string = "";
  message: string | null = null;
  isAuthenticated = false

  constructor(private authService: AuthService,
              private notifier: NotifierService,
              eventBus: EventBusService,
              private preRegService: PreRegistrationService,
              router: Router,
              route: ActivatedRoute,
              subContainer: SubscriptionContainerService) {
    super(eventBus, router, subContainer)
    this.campaignCode = route.snapshot.params['code'];

    this.authService.isAuthenticatedAsync().subscribe(value => this.isAuthenticated = value)
    route.queryParams.subscribe(params => {
      let packageType = params['package_type'];
      this.preRegForm.controls['package_type'].setValue(packageType);
    })
  }

  protected componentName(): string {
    return PreRegistrationComponent.name;
  }

  ngOnInit(): void {
    if (this.isAuthenticated)
      this.navigateByUrl("/", r => {
      })
  }

  preRegister(): void {
    let key = this.componentKey(EventKey.AUTH.LOGIN_SUCCESS)
    let data: ICampaignLeadReq = {
      title: this.preRegForm.value.name!!,
      phone: this.preRegForm.value.phone!!,
      email: this.preRegForm.value.email ?? "",
      description: 'Chosen Package: ' + this.preRegForm.value.package_type!! + '<br/> Business Details: ' + this.preRegForm.value.business_type!!,
    }
    this.preRegService.preRegister(key, AuthEndpoint.PRE_REGISTER.POST(this.campaignCode), data);
    this.subscribe(key, null, value => {
      this.message = translations['WillGetBackSoon'];
      this.notifier.success("Thank you!", translations['WillGetBackSoon']);
      setTimeout(() => {
        window.location.href = "https://cognitox.org"
      }, 3000)
    })
    this.subscribe(this.getMultiErrorKey(key, 1), '/auth/login', value => {
      this.notifier.error(
        "Something went wrong!",
        this.message = "Something went wrong! \nPlease try again or contact info@cognitox.org if problem persists."
      );
    });
    this.subscribe(this.getMultiErrorKey(key, 2), '/auth/login', value => {
      this.notifier.warning("Login Failed!", 'Wrong credentials or missing access rights to application.');
    });
  }


}
